
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 26 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.068 0a8.478 8.478 0 01-3.493.699 8.478 8.478 0 01-3.493-.7L5.938 1.049 0 5.24l3.144 5.24 2.794-1.398v12.924s5.19.35 6.616.35h.042c1.425 0 6.616-.35 6.616-.35V9.082l2.794 1.397 3.144-5.24-5.938-4.191L16.068 0z","fill":"#809D99"}})])
          )
        }
      }
    